<template>
  <div class="navbar">
    <a href="https://m.zhuokao360.com/">
      <i class="iconfont iconhome"></i>
    </a>
    <a href="https://m.zhuokao360.com/download">
      <i class="iconfont iconapp"></i>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'DetailNavbar',
  };
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  padding: 5px 15px;
  background-color: rgba(0, 0, 0, 0.15);
}

.navbar .iconfont {
  font-size: 20px;
  color: #fff;
}
</style>
